// extracted by mini-css-extract-plugin
module.exports = {"item":"selectitem_item__IofId"};